import { render, staticRenderFns } from "./ShowsComp.vue?vue&type=template&id=68d8ae41"
import script from "./ShowsComp.vue?vue&type=script&lang=ts"
export * from "./ShowsComp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports